import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { withStyles, Button, CircularProgress, Typography, FormGroup, Paper, Slider, InputLabel, FormControl, TextField, Grid } from "@material-ui/core";
import { connect } from "react-redux";
import { BackButton, hasPermission } from '../../../../sc-utilities';
import * as diagnoseCaseActions from "../../../../sc-settings/CustomerDiagnoseCase/store/customerDiagnoseCaseActions";
import * as adminDiagnoseCaseActions from "../../../../sc-admin/AdminDiagnoseCase/store/adminDiagnoseCaseActions";
import History from "../../../../../History";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    form: {
        width: '95%',
        margin: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    },
});

const FormFields = {
    battery_cycle_threshold: "battery_cycle_threshold"
}

function valueText(value) {
    return `${value}%`;
}
const DeviceCaseSupportedDiagnoseDetailsBattery = (props) => {
    const { classes, translations, permissions, onUpdateAdminDiagnoseCaseParams, onUpdateCustomerDiagnoseCaseParams, activeCustomerID } = props;

    const diagnoseCase = props.location.state.redirectOptions?.rowData;
    
    const caseParams = diagnoseCase?.ThresholdParams || {};
    
    const isSystemDiagnoseCase = props.location.state?.redirectOptions?.isSystemDiagnoseCase ?? false;

    const initialValues = {
        power_threshold: caseParams?.power_threshold ?? 70,
        battery_cycle_threshold: caseParams?.battery_cycle_threshold ?? 0,
    }

    const hasDiagnoseCaseUpdatePermission = hasPermission(permissions, isSystemDiagnoseCase ? "diagnose_case_update" : "customer_diagnose_case_update");

    const formSettings = {
        Validation: {
            power_threshold: Yup.number(),
            battery_cycle_threshold: Yup.number()
        },
        FormTitle: translations["update_parameters"] || "Update parameters",
        ButtonSubmit:
            hasDiagnoseCaseUpdatePermission ?
                {
                    Title: translations["save"] || "SAVE"
                } : null
    }

    const handleEdit = async (data) => {
        isSystemDiagnoseCase ?
            await onUpdateAdminDiagnoseCaseParams({ CaseParams: { power_threshold: data.power_threshold, battery_cycle_threshold: data.battery_cycle_threshold }, DiagnoseCaseID: diagnoseCase.DiagnoseCaseID }) :
            await onUpdateCustomerDiagnoseCaseParams({ CaseParams: { power_threshold: data.power_threshold, battery_cycle_threshold: data.battery_cycle_threshold }, DiagnoseCaseID: diagnoseCase.DiagnoseCaseID, ActiveCustomerID: activeCustomerID });
        History.goBack();
    }
    return (
        <Paper className={classes.root}>
            {BackButton(translations, classes.customTooltip)}
            <Formik
                initialValues={initialValues}
                enableReinitialize
                onSubmit={handleEdit}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, isSubmitting, isValid, dirty, handleSubmit, handleChange, setFieldValue } = formikProps;
                    return (
                        <form className={classes.form} onSubmit={handleSubmit}>
                            <>
                                <Typography align='center' variant={"h5"}>{translations['battery'] || 'Battery'}</Typography>
                                <InputLabel shrink style={{ fontSize: '1.3rem' }}>{translations["power_threshold"] || "Select power threshold"}</InputLabel>
                                <FormGroup>
                                    <FormControl className={classes.formControl} margin={"dense"}>
                                        <Slider
                                            style={{ paddingTop: 30 }}
                                            value={values.power_threshold}
                                            valueLabelFormat={valueText}
                                            aria-label="Power threshold"
                                            valueLabelDisplay="on"
                                            onChange={(_, value) => setFieldValue('power_threshold', value)} />
                                    </FormControl>
                                </FormGroup>
                                <Grid item xs={12} sm={6}>
                                    <FormGroup>
                                        <FormControl className={classes.formControl} margin={"dense"}>
                                            <TextField
                                                name={FormFields.battery_cycle_threshold}
                                                value={values.battery_cycle_threshold}
                                                label={`${translations["battery_cycle_threshold"] || "Battery cycle threshold"}`}
                                                margin={"dense"}
                                                fullWidth
                                                type={"number"}
                                                onChange={handleChange}
                                                InputProps={{ inputProps: { min: 0 } }}
                                            />
                                        </FormControl>
                                    </FormGroup>

                                </Grid>
                                <div>
                                    {formSettings.ButtonSubmit ? (
                                        <Button
                                            fullWidth={true}
                                            className={classes.submit}
                                            variant="contained"
                                            color={formSettings.ButtonSubmit.Color}
                                            type="submit"
                                            style={{ color: isSubmitting || !(isValid && dirty) ? null : 'white' }}
                                        >
                                            {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                        </Button>
                                    ) : null}
                                </div>
                            </>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
}
const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID ?? null,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onUpdateAdminDiagnoseCaseParams: params => dispatch(adminDiagnoseCaseActions.updateAdminDiagnoseCaseParams(params)),
        onUpdateCustomerDiagnoseCaseParams: params => dispatch(diagnoseCaseActions.updateCustomerDiagnoseCaseParams(params)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DeviceCaseSupportedDiagnoseDetailsBattery));